import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-aff283aa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LaborDetailTitleValue = _resolveComponent("LaborDetailTitleValue");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LaborDetailTitleValue, {
    title: "项目特色",
    value: $props.laboratoryItemDetail.materials_feature || '-',
    "show-title": false
  }, null, 8, ["value"])])]);
}